import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { PollQuestionResponse } from '../../../../../../api/types/settings/settings-all';
import { updateQuestionOperation } from '../operations/update-question-operation';

interface EditQuestionDialogProps {
  pollId: number;
  question: PollQuestionResponse;
  closeDialog: () => void;
}

export const EditQuestionDialog: React.FC<EditQuestionDialogProps> = ({
  pollId,
  question,
  closeDialog,
}) => {
  const [questionText, setQuestionText] = useState(question.questionText);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    await updateQuestionOperation(
      pollId,
      question.id,
      questionText,
      setLoading,
      closeDialog,
    );
  };

  const isValid = questionText.trim().length >= 2;

  return (
    <div style={{ direction: 'rtl' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: 500,
            color: '#374151',
          }}
        >
          טקסט השאלה
        </label>
        <InputText
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
          placeholder="הזן את טקסט השאלה"
          style={{ width: '100%' }}
          autoFocus
        />
      </div>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end',
          marginTop: '24px',
          paddingTop: '16px',
          borderTop: '1px solid #e5e7eb',
        }}
      >
        <Button
          label="ביטול"
          icon="pi pi-times"
          className="p-button-outlined p-button-secondary"
          onClick={closeDialog}
          disabled={loading}
        />
        <Button
          label="עדכון שאלה"
          icon="pi pi-check"
          onClick={handleSubmit}
          loading={loading}
          disabled={!isValid}
        />
      </div>
    </div>
  );
};
